import { Component, OnInit } from '@angular/core';
import { CoreConstants } from '../../../../core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public applicationDetails = CoreConstants.applicationDetails;

  constructor() {
  }

  ngOnInit(): void {
  }

  /**
   * Getter for current year
   */
  get currentYear(): number {
    return new Date().getFullYear();
  }
}
